import * as Types from '../types.generated';

import gql from 'graphql-tag';
export type TitleFieldsFragment = { __typename: 'ComponentTitle', content?: { __typename: 'ComponentTitleContent', json: any } | null };

export const TitleFieldsFragmentDoc = gql`
    fragment titleFields on ComponentTitle {
  __typename
  content {
    json
  }
}
    `;